export const supplierConstants = {
  SUPPLIERS_LOADED: 'SUPPLIERS_LOADED',
  SUPPLIER_LOADED: 'SUPPLIER_LOADED',
  SUPPLIER_CREATED: 'SUPPLIER_CREATED',
  SUPPLIER_UPDATED: 'SUPPLIER_UPDATED',
  SUPPLIER_DELETED: 'SUPPLIER_DELETED',
  SUPPLIER_ERRORS: 'SUPPLIER_ERRORS',
  SUPPLIER_RESET: 'SUPPLIER_RESET'
};



// WEBPACK FOOTER //
// ./src/_constants/supplier.constants.js